import globals from "@lvt/globals";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/react";
import { createBrowserHistory } from "history";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";

import client from "@/api/client";
import "@fontsource/montserrat";
import "@fontsource/rajdhani";
import "@fontsource/source-sans-pro";
import { FeatureFlagServiceImpl } from "@/api/services/implementations/featureFlag";
import { App } from "@/common/containers";
import "@/styles";
import { FeatureFlagContextWrapper } from "@/common/contexts/FeatureFlagContext";
import * as FullStory from "@/utilities/hooks/fullstory";


const featureFlagService = FeatureFlagServiceImpl(client);
const history = createBrowserHistory();

// sentry configuration
if (globals.sentry.dsn) {
    Sentry.init({
        dsn: globals.sentry.dsn,
        environment: globals.sentry.environment,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
            }),
            new Sentry.Replay(),
        ],
        normalizeDepth: 3,
        replaysOnErrorSampleRate: 0.1,
        replaysSessionSampleRate: 0.05,
        tracesSampleRate: globals.sentry.sampleRate,
    });
}

// Note this our lib, not the fullstory api.  See: "utilities/hooks/fullstory.ts"
const fullStoryContext = FullStory.setup(globals.fullStory);

ReactDOM.render(
    <FeatureFlagContextWrapper service={featureFlagService}>
        <FullStory.Context.Provider value={fullStoryContext}>
            <Router history={history}>
                <App
                    tokenUrl={globals.authentication.tokenUrl}
                    portalUrl={globals.portal.url}
                    d3Url={globals.d3.url}
                    vmsUrl={globals.vms.url}
                    selfServiceUrl={globals.servicePortal.url}
                    realtimeEventsUrl={globals.realtimeEvents.url}
                    nextAppUrl={globals.nextApp.url}
                    walkMeScript={globals.walkMe.scriptSrc}
                />
            </Router>
        </FullStory.Context.Provider>
    </FeatureFlagContextWrapper>,
    document.getElementById("root"),
);

/* PROJECT_NAME:removed */

/* [prod:start] */
// production message
console.log(
    "%c[PRODUCTION]",
    "background-color: #4287f5; color: #ffffff; font-weight: bold; padding: 4px 8px; border-radius: 4px;",
);
/* [prod:end] */
